import { useState, type FormEvent } from 'react'
import { ApiError, type LocationOption, type SignupPayload } from './api'

interface SignupFormProps {
  locations: LocationOption[]
  onSubmit: (payload: SignupPayload) => Promise<void>
}

export function SignupForm({ locations, onSubmit }: SignupFormProps) {
  const [sending, setSending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = new FormData(e.currentTarget)
    setSending(true)
    setError(null)
    try {
      await onSubmit({
        firstName: String(form.get('firstName') ?? '').trim(),
        lastName: String(form.get('lastName') ?? '').trim(),
        phone: String(form.get('phone') ?? '').trim(),
        email: String(form.get('email') ?? '').trim() || undefined,
        comment: String(form.get('comment') ?? '').trim() || undefined,
        locationId: Number(form.get('locationId')),
      })
    } catch (err: unknown) {
      setError(
        err instanceof ApiError ? err.message : 'Не удалось записаться',
      )
    } finally {
      setSending(false)
    }
  }

  return (
    <form className="form" onSubmit={handleSubmit}>
      <label>
        Имя <span className="required">*</span>
        <input name="firstName" required autoComplete="given-name" />
      </label>
      <label>
        Фамилия <span className="required">*</span>
        <input name="lastName" required autoComplete="family-name" />
      </label>
      <label>
        Телефон <span className="required">*</span>
        <input
          name="phone"
          type="tel"
          required
          placeholder="+7 999 111-22-33"
          autoComplete="tel"
        />
      </label>
      <label>
        Почта <span className="optional">необязательно</span>
        <input name="email" type="email" autoComplete="email" />
      </label>
      <label>
        Ваш коворкинг <span className="required">*</span>
        <select name="locationId" required defaultValue="">
          <option value="" disabled>
            Выберите коворкинг
          </option>
          {locations.map((l) => (
            <option key={l.id} value={l.id}>
              {l.name}
            </option>
          ))}
        </select>
      </label>
      <label>
        Комментарий <span className="optional">необязательно</span>
        <textarea name="comment" rows={3} />
      </label>

      {error && <p className="error">{error}</p>}

      <button type="submit" disabled={sending}>
        {sending ? 'Записываем…' : 'Записаться'}
      </button>
    </form>
  )
}
